import { HttpParams } from '@angular/common/http';

export const cleanEmptyParams = (obj: Record<string, any>) => {
  const filtered = Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== undefined && value !== '' && value !== null
    )
  );

  let params = new HttpParams();
  Object.entries(filtered).forEach(([key, val]) => {
    params = params.set(key, String(val));
  });

  return params;
};
